"use client"

import { useEffect, useRef } from "react"
import { getDatabase, ref, onValue } from "firebase/database"

const SystemNotificationManager = ({ isOnDashboard }) => {
  const lastNotificationTime = useRef(Date.now())
  const notificationPermission = useRef("default") // "default" | "granted" | "denied"

  // Request notification permission on mount
  useEffect(() => {
    const requestPermission = async () => {
      if ("Notification" in window) {
        const permission = await Notification.requestPermission()
        notificationPermission.current = permission
      }
    }
    requestPermission()
  }, [])

  // Monitor notifications when user is not on dashboard
  useEffect(() => {
    if (isOnDashboard || notificationPermission.current !== "granted") {
      return
    }

    const db = getDatabase()
    const types = [
      "Steel Orders",
      "New Query",
      "Negotiations",
      "New Orders",
      "Quotations",
      "Raised Issues",
      "Machinery Orders",
      "transportGoods",
      "Transport Request",
      "Stop_Order",
      "Refund",
      "finance",
       "Payment Confirmation",
      "PaymentProofAdded",
      "Document Verification",
      "Docs_Request",
    ]

    const highPriorityTypes = ["New Orders", "Steel Orders", "Machinery Orders", "Raised Issues", "Stop_Order"]

    const unsubscribeFunctions = []

    types.forEach((type) => {
      const notificationsRef = ref(db, `supplier_notifications/${type}`)

      const unsubscribe = onValue(notificationsRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val()

          Object.keys(data).forEach((userId) => {
            Object.entries(data[userId]).forEach(([notifId, notification]) => {
              const notificationTime = new Date(notification.timestamp).getTime()

              // Only show notifications that are newer than when we started monitoring
              if (notificationTime > lastNotificationTime.current && !notification.seen) {
                const isHighPriority = highPriorityTypes.includes(type)

              showSystemNotification({
  title: `${type} - Admin Alert`,
  body: `${notification.message || `New ${type.toLowerCase()} notification`} • ${new Date(
    notification.timestamp
  ).toLocaleString()}`,
  icon: "/favicon.ico",
  tag: `admin-${type}-${notifId}`,
  requireInteraction: true,   // 🔥 force notification popup until dismissed
  data: {
    type,
    notificationId: notifId,
    userId,
    timestamp: notification.timestamp,
  },
})

              }
            })
          })
        }
      })

      unsubscribeFunctions.push(unsubscribe)
    })

    return () => {
      unsubscribeFunctions.forEach((unsubscribe) => unsubscribe())
    }
  }, [isOnDashboard])

  const showSystemNotification = (options) => {
    if ("Notification" in window && notificationPermission.current === "granted") {
      const notification = new Notification(options.title, {
        ...options,
      })

      notification.onclick = () => {
        // Focus the window and navigate to dashboard
        window.focus()

        // Dispatch custom event to handle navigation
        const event = new CustomEvent("systemNotificationClick", {
          detail: options.data,
        })
        window.dispatchEvent(event)

        notification.close()
      }

      // Auto-close non-high-priority notifications after 5 seconds
      if (!options.requireInteraction) {
        setTimeout(() => {
          notification.close()
        }, 5000)
      }
    }
  }

  return null
}

export default SystemNotificationManager
